import React from 'react';
import FileList from '../components/FileList';
import PageHeader from '../components/common/PageHeader';
import PageContainer from '../components/common/PageContainer';

function Files() {
  return (
    <PageContainer>
      <PageHeader title="ファイル管理" />
      <FileList />
    </PageContainer>
  );
}

export default Files;
